module.exports = __webpack_public_path__ + "img/5c18eaaa57ba4d6095197be8903b8e9d.png";